import React from 'react';
import { useLocation } from 'react-router-dom';

import { AnalyticsPageView } from '@backrs_ui/common-ui';

import { usePostHog } from 'posthog-js/react';

interface PostHogPageViewShellProps {
  children: React.ReactNode;
}

export const PostHogPageViewShell: React.FC<PostHogPageViewShellProps> = ({ children }) => {
  const location = useLocation();
  const postHog = usePostHog();
  const analyticsEnabled = process.env.REACT_APP_ANALYTICS_ENABLED === 'true';

  return (
    <AnalyticsPageView enabled={analyticsEnabled} posthog={postHog} location={location}>
      {children}
    </AnalyticsPageView>
  );
};
